import cn from 'classnames'

export const statusIconClassName = cn(
   'absolute  bottom-0 right-0 outline-4 outline-white'
)

export const avatarWithIconContainer = cn(
   ' flex flex-row justify-center items-center '
)

export const avatarWithTextContainerClassName = cn(
   ' flex flex-row justify-center items-center '
)

export const avatarContainerClassName = cn('relative w-fit')

export const avatarWithImageClassName = cn('w-full h-full object-cover')
